export const INDUSTRY_OPTIONS = [
  { value: 'food-and-beverage', label: 'Food & Beverage' },
  { value: 'pharmaceuticals', label: 'Pharmaceuticals' },
  { value: 'cosmetics-and-personal-care', label: 'Cosmetics & Personal Care' },
  { value: 'homecare-and-cleaning', label: 'Homecare & Cleaning' },
  { value: 'agrochemicals-and-pesticides', label: 'Agrochemicals & Pesticides' },
  { value: 'automotive-and-lubricants', label: 'Automotive & Lubricants' },
  { value: 'other', label: 'Other' },
];

export const STATE_OPTIONS = [
  { value: 'andaman-and-nicobar-islands', label: 'Andaman and Nicobar Islands' },
  { value: 'andhra-pradesh', label: 'Andhra Pradesh' },
  { value: 'arunachal-pradesh', label: 'Arunachal Pradesh' },
  { value: 'assam', label: 'Assam' },
  { value: 'bihar', label: 'Bihar' },
  { value: 'chandigarh', label: 'Chandigarh' },
  { value: 'chhattisgarh', label: 'Chhattisgarh' },
  { value: 'dadra-and-nagar-haveli-and-daman-and-diu', label: 'Dadra and Nagar Haveli and Daman and Diu' },
  { value: 'delhi', label: 'Delhi' },
  { value: 'goa', label: 'Goa' },
  { value: 'gujarat', label: 'Gujarat' },
  { value: 'haryana', label: 'Haryana' },
  { value: 'himachal-pradesh', label: 'Himachal Pradesh' },
  { value: 'jammu-and-kashmir', label: 'Jammu and Kashmir' },
  { value: 'jharkhand', label: 'Jharkhand' },
  { value: 'karnataka', label: 'Karnataka' },
  { value: 'kerala', label: 'Kerala' },
  { value: 'ladakh', label: 'Ladakh' },
  { value: 'lakshadweep', label: 'Lakshadweep' },
  { value: 'madhya-pradesh', label: 'Madhya Pradesh' },
  { value: 'maharashtra', label: 'Maharashtra' },
  { value: 'manipur', label: 'Manipur' },
  { value: 'meghalaya', label: 'Meghalaya' },
  { value: 'mizoram', label: 'Mizoram' },
  { value: 'nagaland', label: 'Nagaland' },
  { value: 'odisha', label: 'Odisha' },
  { value: 'puducherry', label: 'Puducherry' },
  { value: 'punjab', label: 'Punjab' },
  { value: 'rajasthan', label: 'Rajasthan' },
  { value: 'sikkim', label: 'Sikkim' },
  { value: 'tamil-nadu', label: 'Tamil Nadu' },
  { value: 'telangana', label: 'Telangana' },
  { value: 'tripura', label: 'Tripura' },
  { value: 'uttar-pradesh', label: 'Uttar Pradesh' },
  { value: 'uttarakhand', label: 'Uttarakhand' },
  { value: 'west-bengal', label: 'West Bengal' },
  { value: 'other', label: 'Other' },
];

export const PRODUCT_OPTIONS = [
  { value: 'pet-bottles', label: 'PET Bottles' }, 
  { value: 'beverage-can', label: 'Beverage Can' },
  { value: 'food-can', label: 'Food Can' },
  { value: 'pet-preforms', label: 'PET Preforms' },
  { value: 'sealing-machine', label: 'Sealing Machine' },
  { value: 'be-our-distributor', label: 'Be Our Distributor' },
  { value: 'other', label: 'Other' },
];
